import httpRequest from '@/utils/request';
import axios from 'axios';


const CancelToken = axios.CancelToken;

const quotationUrl = '/Quotation';

const generateUrlBySolutionId = (solutionId: string): string => {
  return `${quotationUrl}/${solutionId}`;
};

const updateStatusUrl = (id: string): string => {
  return `${quotationUrl}/${id}/status`;
};

export const searchSolution = (
  params: ISolution.IRequest.ISearchSolution,
): Promise<ISolution.IResponse.ISolutionData> => {
  return httpRequest.get(quotationUrl, {
    params,
  });
};

export const updateSolution = (
  params: ISolution.IRequest.IUpdateQuotation,
): Promise<IResponseData.IBaseData> => {
  const url = generateUrlBySolutionId(params.solutionId);
  return httpRequest.post(url, params.data);
};

export let cancel: any;

export const getSolutionDetail = (
  params: ISolution.IRequest.ISearchSolution,
): Promise<ISolution.IResponse.ISolutionData> => {
  return httpRequest.get(quotationUrl, {
    params,
    cancelToken: new CancelToken((c) => {
      cancel = c;
    }),
  });
};

export const approvalSolution = (solutionId: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(solutionId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Approved',
    },
  });
};
export const rejectSolution = (solutionId: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(solutionId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Rejected',
    },
  });
};
export const cancelSolution = (solutionId: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(solutionId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Cancel',
    },
  });
};
export const closeSolution = (solutionId: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(solutionId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Closed',
    },
  });
};

export const deleteSolution = (solutionId: string): Promise<IResponseData.IBaseData> => {
  const url = generateUrlBySolutionId(solutionId);
  return httpRequest.delete(url);
};
